import React from 'react';
import { inferFileType } from '../../../utils/fileOverrides';
import { PlayGlyph, TypeGlyph } from './FileUploadIcons';

export const FileUploadPendingRow = ({ job, onRetry, onDismiss }) => {
  const pct = Math.round(job.progress || 0);
  const fileType = inferFileType(job.file?.type, job.filename);
  return (
  <li
    className={`file-upload-block__file${
      job.error ? ' file-upload-block__file--error' : ''
    }`}
  >
    <span className={`file-upload-block__thumb${job.localThumb ? ' is-image' : ''}`}>
        {job.localThumb ? (
        <img src={job.localThumb} alt="" />
      ) : (
        <TypeGlyph fileType={fileType} />
      )}
      {fileType === 'video' && job.localThumb ? (
        <span className="file-upload-block__play" aria-hidden>
          <PlayGlyph />
        </span>
      ) : null}
      {!job.error ? <span className="file-upload-block__pct">{pct}%</span> : null}
    </span>
    <span className="file-upload-block__meta">
      <span className="file-upload-block__file-name" title={job.filename}>
        {job.filename}
      </span>
      {job.error ? (
        <span className="file-upload-block__file-size">{job.error}</span>
      ) : (
        <span className="file-upload-block__file-size file-upload-block__file-size--progress">
          <span className="file-upload-block__track" aria-hidden>
            <span
              className="file-upload-block__bar"
              style={{ width: `${Math.max(6, pct)}%` }}
            />
          </span>
          <span className="file-upload-block__pct-inline">{pct}%</span>
        </span>
      )}
    </span>
    {job.error ? (
      <span className="file-upload-block__actions is-visible">
        <button
          type="button"
          className="file-upload-block__text-action"
          onClick={() => onRetry(job)}
        >
          Retry
        </button>
        <button
          type="button"
          className="file-upload-block__text-action"
          onClick={() => onDismiss(job.id)}
        >
          Dismiss
        </button>
      </span>
    ) : null}
  </li>
  );
};
